<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col cols="12" sm="6" lg="3" :class="setClass(0)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-3">
			            <p class="pl-2 pl-xl-3">Messaggi Inviati</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">

                        <campaign-kpi v-if="loaded"
                            name="sent"
                            category="Inviate"
                            :counter="stats.sent"
                            :total="stats.total"
                            :colorIndex="0"
                        ></campaign-kpi>

                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>

        <v-col cols="12" sm="6" lg="3" :class="setClass(1)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-3">
			            <p class="pl-2 pl-xl-3">Messaggi Consegnati</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">

                        <campaign-kpi v-if="loaded"
                            name="delivered"
                            category="Consegnate"
                            :counter="stats.delivered"
                            :total="stats.sent"
                            :colorIndex="1"
                        ></campaign-kpi>

                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>

        <v-col cols="12" sm="6" lg="3" :class="setClass(2)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-3">
			            <p class="pl-2 pl-xl-3">Messaggi Letti</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">

                        <campaign-kpi v-if="loaded"
                            name="read"
                            category="Lette"
                            :counter="stats.read"
                            :total="stats.delivered"
                            :colorIndex="2"
                        ></campaign-kpi>

                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>

        <v-col cols="12" sm="6" lg="3" :class="setClass(3)">
            <v-hover v-slot:default="{ hover }">
                <v-card :elevation="hover ? 4 : 2" class="background-2 round-card">
                    <v-card-title class="pa-3">
			            <p class="pl-2 pl-xl-3">Messaggi Falliti</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">

                        <campaign-kpi v-if="loaded"
                            name="failed"
                            category="Fallite"
                            :counter="stats.failed"
                            :total="stats.total"
                            :colorIndex="3"
                        ></campaign-kpi>

                    </v-card-text>
                </v-card>
            </v-hover>
        </v-col>

        <whatsapp-campaign-analytics-recipients
            class="pr-xl-2 pr-lg-2 mt-4"
            :id="id"
            title="Messaggi Inviati"
            :url="'/sent-whatsapp-recipients'"
            :headers="sentRecipientsHeaders"
            tooltip="Messaggi inviati con successo"
        ></whatsapp-campaign-analytics-recipients>

        <whatsapp-campaign-analytics-recipients
            class="pl-xl-2 pl-lg-2 mt-4"
            :id="id"
            title="Messaggi Consegnati"
            :url="'/delivered-whatsapp-recipients'"
            :headers="deliveredRecipientsHeaders"
            tooltip="Messaggi consegnati ai destinatari"
        ></whatsapp-campaign-analytics-recipients>

        <whatsapp-campaign-analytics-recipients
            class="pr-xl-2 pr-lg-2"
            :id="id"
            title="Messaggi Letti"
            :url="'/read-whatsapp-recipients'"
            :headers="readRecipientsHeaders"
            tooltip="Messaggi letti dai destinatari"
        ></whatsapp-campaign-analytics-recipients>

        <whatsapp-campaign-analytics-recipients
            class="pl-xl-2 pl-lg-2"
            :id="id"
            title="Messaggi Falliti"
            :url="'/failed-whatsapp-recipients'"
            :headers="failedRecipientsHeaders"
            tooltip="Messaggi non inviati per errori"
        ></whatsapp-campaign-analytics-recipients>

        <whatsapp-campaign-analytics-recipients
            class="pr-xl-2 pr-lg-2"
            style-class="col-12"
            :id="id"
            title="Numeri Non Validi"
            :url="'/invalid-whatsapp-recipients'"
            :headers="invalidRecipientsHeaders"
            tooltip="Destinatari con numero di telefono non valido"
        ></whatsapp-campaign-analytics-recipients>

    </v-row>
</template>

<script>

    import CampaignKpi from '@/components/modules/mailmarketing/CampaignKpi'
    import WhatsappCampaignAnalyticsRecipients from '@/components/modules/whatsapp/WhatsappCampaignAnalyticsRecipients'

    export default {
        name: 'whatsapp-campaign-analytics',
        components: {
            CampaignKpi,
            WhatsappCampaignAnalyticsRecipients
        },

        props: {
            id: Number,
        },

        data() {
            return {
                stats: {
                    total: 0,
                    sent: 0,
                    delivered: 0,
                    read: 0,
                    failed: 0
                },
                loaded: false,
                sentRecipientsHeaders: [
                    {
                        text: 'Azienda',
                        value: 'company'
                    },
                    {
                        text: 'Contatto',
                        value: 'contact'
                    },
                    {
                        text: 'Numero Telefono',
                        value: 'telephone_number'
                    },
                    {
                        text: 'Inviato il',
                        value: 'created_at',
                        type: 'datetime'
                    },
                ],
                deliveredRecipientsHeaders: [
                    {
                        text: 'Azienda',
                        value: 'company'
                    },
                    {
                        text: 'Contatto',
                        value: 'contact'
                    },
                    {
                        text: 'Numero Telefono',
                        value: 'telephone_number'
                    },
                    {
                        text: 'Consegnato il',
                        value: 'whatsapp_delivered_at',
                        type: 'datetime'
                    },
                ],
                readRecipientsHeaders: [
                    {
                        text: 'Azienda',
                        value: 'company'
                    },
                    {
                        text: 'Contatto',
                        value: 'contact'
                    },
                    {
                        text: 'Numero Telefono',
                        value: 'telephone_number'
                    },
                    {
                        text: 'Letto il',
                        value: 'whatsapp_read_at',
                        type: 'datetime'
                    },
                ],
                failedRecipientsHeaders: [
                    {
                        text: 'Azienda',
                        value: 'company'
                    },
                    {
                        text: 'Contatto',
                        value: 'contact'
                    },
                    {
                        text: 'Numero Telefono',
                        value: 'telephone_number'
                    },
                    {
                        text: 'Errore',
                        value: 'whatsapp_error'
                    },
                ],
                invalidRecipientsHeaders: [
                    {
                        text: 'Azienda',
                        value: 'company'
                    },
                    {
                        text: 'Contatto',
                        value: 'contact'
                    },
                    {
                        text: 'Numero Telefono',
                        value: 'telephone_number'
                    },
                    {
                        text: 'Motivo',
                        value: 'whatsapp_error'
                    },
                ],
            }
        },

        methods: {

            initialize() {
                this.axios.get('whatsappcampaigns-stats/' + this.id).then(response => {
                    this.stats = response.data.data.stats

                    this.$store.commit('endProgress')
                    this.loaded = true

                }, response => {
                    // error callback
                })
            },

            setClass(i) {
                if(this.$vuetify.breakpoint.xl) {
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-2'
                    } else if(i == 3) {
                        return 'pa-0 pl-2'
                    } else {
                        return 'pa-0 pr-2 pl-2'
                    }
                }
                if(this.$vuetify.breakpoint.lg) {
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-2'
                    } else if(i == 3) {
                        return 'pa-0 pl-2'
                    } else {
                        return 'pa-0 pr-2 pl-2'
                    }
                }
                if(this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md){
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-2'
                    } else if(i == 2) {
                        return 'pa-0 pl-0 pr-2 pt-4'
                    } else if(i == 3) {
                        return 'pa-0 pl-2 pr-0 pt-4'
                    } else {
                        return 'pa-0 pl-2 pr-0'
                    }
                }
                if(this.$vuetify.breakpoint.xs) {
                    if(i == 0) {
                        return 'pa-0 pl-0 pr-0'
                    }
                    return 'pa-0 pl-0 pr-0 pt-4'
                }
            },
        },

        created() {
            this.initialize()
        },

    }
</script>

<style>

</style>
